import { render, staticRenderFns } from "./BitcoinIcon.vue?vue&type=template&id=42e63a3f&"
import script from "./BitcoinIcon.vue?vue&type=script&lang=ts&"
export * from "./BitcoinIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports